import { createStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import serviceEventReducer from './slices/serviceEventSlice';
import appReducer from './slices/AppSlice';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
var persistConfig = {
    key: 'root',
    storage: storage,
};
// combine all reducers to one
var allReducers = combineReducers({ serviceEvent: serviceEventReducer, app: appReducer });
var rootReducer = function (state, action) {
    if (action.type === 'CLEAR_STATE') {
        state = { app: { lastServiceEventId: state.serviceEvent.serviceEventId } };
        localStorage.clear();
    }
    return allReducers(state, action);
};
// wrap combined reducer to persist
var persistedReducer = persistReducer(persistConfig, rootReducer);
var store = createStore(persistedReducer, window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__());
export default store;
export var persistor = persistStore(store);
